export default __webpack_public_path__ + "static/media/suzuki-logo-small.7f627923.png";